import React, { Component } from 'react';
import {AppBar,Toolbar,Typography,Link} from "@material-ui/core";
import logo from "../../gifs/logo.svg" 
import "./Navbar.css";

class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        let bcolor,tcolor;
        if(this.props.color!=null){
            bcolor=this.props.color;
            tcolor=this.props.tcolor;
        }
        else{
            bcolor="#00b8f5"
            tcolor="white"
        }
        return ( 
            <AppBar position="static" className="nav" style={{flexGrow:1,backgroundColor:bcolor,color:tcolor}} color="transparent" elevation={0}>
                <Toolbar>
                    <Typography className="typo-nav" variant="h5" onClick={()=>{
                        document.location.href="/";
                    }}><img src={logo} style={{height:`7vh`,width:`7vw`}}/><b style={{fontSize:"1.7em",fontFamily:`system-ui`,paddingTop:"3vh",paddingLeft:"1vh"}}>Know Search</b></Typography>
                    <Typography className="typo-nav1" variant="h5" onClick={()=>{
                        document.location.href="/";
                    }}><b style={{fontSize:"1.6em",fontFamily:`system-ui`}}></b></Typography>
                    <Typography className="typo-nav1" variant="h5" onClick={()=>{
                        document.location.href="/portfolio-ujjwal";
                    }}><b style={{fontSize:"1.6em",fontFamily:`system-ui`,marginLeft:"2vw"}}>About</b></Typography>
                </Toolbar>
            </AppBar>
         );
    }
}
 
export default Navbar;



// WEBPACK FOOTER //
// ./src/components/NAV/Navbar.js